<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{visible,params}">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getCity } from "@/api/system/city";
import { getWarehouse } from "@/api/storage/warehouse";
import { getAgent } from "@/api/tracker/agent";
// import { getClient } from "@/api/user/client";
// import { getSku } from "@/api/storage/sku";
import Tracker from "@/base/order_tracker";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import cTable from "@/base/common/index";
export default {
  name: "proxyPush",
  components: {
    cTable,
    Tracker
  },
  mounted() {
    // this.header.searchs.forEach(async item => {
    //   if (item.key === "warehouse_id")
    //     item.options = (await getWarehouse()).data.payload.rows;
    // });
  },
  data() {
    return {
      methods: {
        list: proxyErr,
        getAgent,
        pushProxy
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("pushProxy", row, true)
                .then(res => {
                  // this.$Message["success"]({
                  //   background: true,
                  //   content: res.msg,
                  //   duration: 5
                  // });
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("pushProxy"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "agent_name" },
            methods: {
              async list({ field }) {
                let res = (await getAgent({ types: "DELIVERY" })).data.payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "is_success",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("push") + this.$t("tip");
            },
            clearable: true,
            options: [
              { label: "YES", value: "YES" },
              { label: "NO", value: "NO" }
            ]
            // config: { label: "agent_name", value: "agent_name" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("push"),
              type: "push",
              fnName: "pushFun",
              id: 192,
              bind: {
                icon: "md-arrow-up",
                type: "success"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            pushFun() {
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          component: "Button",
          copy: true,
          align: "center",
          bind: {
            type: "primary",
            size: "small"
          },
          width: 150,
          methods: {
            click({ row }) {
              this.$page.getModal("show").setTitle(row.airway_number);
              this.$page.getModal("show").open({ row });
            }
          }
        },
        // {
        //   name: () => this.$t("order_userRef"),
        //   key: "client_refer_code",
        //   align: "center",
        //   minWidth: 100
        // },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
          width: 80
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          align: "center",
          width: 80
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center",
          width: 80
        },
        {
          name: () => this.$t("push") + this.$t("tip"),
          key: "is_success",
          align: "center",
          width: 80
        },
        {
          name: () => this.$t("pushProxy") + this.$t("data"),
          key: "push_agent_data",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("agentT") + this.$t("return_t") + this.$t("data"),
          key: "agent_return_data",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("push") + this.$t("time"),
          key: "create_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        }
      ]
    };
  }
};
</script>
